import React, { useEffect, useState, useCallback } from "react";
import {
  Container,
  Row,
  Col,
  Modal,
  ModalHeader,
  Spinner
} from "reactstrap";
import { Link } from "react-router-dom";
import { isEmpty } from "lodash";

//Import Scrollbar
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

const ChatHistoryModal = ({isOpen, toggle, session = {}, messages = [], loading = false, chatType = "human"}) => {
  const [messageBox, setMessageBox] = useState(null);

  const onImageError = (e) => {
    e.target.src = 'https://storage.googleapis.com/yasa-admin_images/MaleDefaultImg.png'; // Path to your default avatar
  };
  
  const scrollToBottom = useCallback(() => {
    if (messageBox) {
      messageBox.scrollTop = messageBox.scrollHeight + 1000;
    }
  }, [messageBox]);

  useEffect(() => {
    if (!isEmpty(messages)) scrollToBottom();
   
  }, [messages, scrollToBottom]);

  return (
    <Modal size="xl" isOpen={isOpen}>
      <ModalHeader 
        id="myExtraLargeModalLabel" 
        toggle={toggle}
      >
        </ModalHeader>
        <Container fluid>
          <div className="chat-wrapper d-lg-flex gap-1 mx-n4 mt-n4 p-1">
            <div className="user-chat w-100 overflow-hidden">
              <div className="chat-content d-lg-flex">
                <div className="w-100 overflow-hidden position-relative">
                  <div className="position-relative">
                    <div className="p-3 user-chat-topbar">
                      <Row className="align-items-center">
                        <Col sm={4} xs={8}>
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0 d-block d-lg-none me-3">
                              <Link
                                to="#"
                                className="user-chat-remove fs-18 p-1"
                              >
                                <i className="ri-arrow-left-s-line align-bottom"></i>
                              </Link>
                            </div>
                            <div className="flex-grow-1 overflow-hidden">
                              <div className="d-flex align-items-center">
                                <div className="flex-shrink-0 chat-user-img online user-own-img align-self-center me-3 ms-0">
                                    <img
                                      src={session.AgentProfilePic || session.ProfilePictureUrl}
                                      onError={onImageError}
                                      className="rounded-circle avatar-xs"
                                      alt=""
                                    />
                                  <span className={"user-status"}></span>
                                </div>
                                <div className="flex-grow-1 overflow-hidden">
                                  <h5 className="text-truncate mb-0 fs-16">
                                    <a
                                      className="text-reset username"
                                      data-bs-toggle="offcanvas"
                                      href="#userProfileCanvasExample"
                                      aria-controls="userProfileCanvasExample"
                                    >
                                      {`${session?.AgentName || session?.UserName}  (${session.SessionID})`}
                                    </a>
                                  </h5>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>

                    <div className="position-relative" id="users-chat">
                      <PerfectScrollbar
                        className="chat-conversation p-3 p-lg-4"
                        id="chat-conversation"
                        containerRef={ref => setMessageBox(ref)} >
                        <div id="elmLoader"></div>
                        <ul
                          className="list-unstyled chat-conversation-list"
                          id="users-conversation"
                        >
                          
                        { loading ? <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Spinner style={{
                                height: '3rem',
                                width: '3rem',
                                }} className='me-2'> Loading... </Spinner>
                            </div> :
                            messages.map((message, key) => {
                              let isReceived;
                              if (chatType === 'ai') {
                                // For AI chat, IsReceived determines alignment
                                isReceived = message.IsReceived;
                              } else {
                                // For Human chat, RoleID determines alignment
                                isReceived = message.RoleID != 2;
                              }

                              return (
                              <li
                                className={
                                  isReceived
                                    ? " chat-list left"
                                    : "chat-list right"
                                }
                                key={key}
                              >
                                <div className="conversation-list">
                                  {isReceived && (
                                    <div className="chat-avatar">
                                        <img
                                          src={session.AgentProfilePic || session.ProfilePictureUrl}
                                           onError={onImageError}
                                          alt=""
                                        />
                                    </div>
                                  )}

                                  <div className="user-chat-content">
                                    <div className="ctext-wrap">
                                        { message?.MessageType == 3 && message.Message ?
                                          <div className="message-img mb-0">
                                              <div className="message-img-list">
                                                  <div
                                                     style={{
                                                      height: "100%",
                                                      overflowY: "auto",
                                                      overflowX: "hidden",
                                                    }}>
                                                    <iframe
                                                      src={message.Message || ''}
                                                      width="100%"
                                                      height="95%"
                                                      title="PDF Viewer"
                                                      style={{ minHeight: "350px" }}
                                                    >
                                                    </iframe>
                                                  {/* <a
                                                    className="popup-img d-inline-block"
                                                    href={message?.Message}
                                                    target="_blank"
                                                  >
                                                    <img
                                                      src={message?.Message}
                                                      alt=""
                                                      className="rounded border"
                                                    />
                                                  </a> */}

                                                  </div>
                                              </div>
                                          </div> :
                                          message?.MessageType == 2 && message.Message ?
                                          <div className="message-img mb-0">
                                            <div className="message-img-list">
                                              <div>
                                                <a
                                                  className="popup-img d-inline-block"
                                                  href={message?.Message}
                                                  target="_blank"
                                                >
                                                  <img
                                                    src={message?.Message}
                                                    alt=""
                                                    className="rounded border"
                                                  />
                                                </a>
                                              </div>
                                            </div>
                                          </div> :
                                          <div className="ctext-wrap-content">
                                            <p className="mb-0 ctext-content">
                                              {message.Message}
                                            </p>
                                            {/* <p className="mb-0 ctext-content">
                                              {message.Message}
                                            </p> */}
                                          </div>
                                        }
                                    </div>
                                    <div className="conversation-name">
                                      <small className="text-muted time">
                                        {new Date(message.CreatedDate).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                      </small>{" "}
                                      <span className="text-success check-message-icon">
                                        <i className="ri-check-double-line align-bottom"></i>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </li>
                            )})
                        }
                        </ul>
                      </PerfectScrollbar>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
    </Modal>
  );
};

export default ChatHistoryModal;
